import { Pipe, PipeTransform } from '@angular/core';
import { LicenseCode } from '@account-users/account/models/LicenseCode';
import { License } from '@account-users/account/models/License';

@Pipe({ name: 'permissionNamePipe' })
export class PermissionNamePipe implements PipeTransform {
  transform(licenses: License[], licenseCode: LicenseCode) {
    return licenses.find((tool) => tool.code === licenseCode).displayName;
  }
}
